import type { BlendState } from './reducer';

export const getFailedActionsForParent = (
  { blend }: { blend: BlendState },
  parent: string,
) => Object.keys(blend[parent] || {}).map((id) => blend[parent][id]);
